
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';
import 'swiper/css/swiper.css';

export default BaseCmsBlock.extend({
  name: 'DirectionsBenefitsWorkingWithUsBlock',
  data: function () {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 12,
        breakpoints: {
          860: {
            slidesPerColumnFill: 'row',
            spaceBetween: 16,
            slidesPerView: 4,
          },
          1024: {
            slidesPerColumnFill: 'row',
            spaceBetween: 21,
            slidesPerColumn: this.values.items.length === 4 ? 1 : 2,
            slidesPerView: this.values.items.length === 4 ? 4 : 3,
          }
        },
      },
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
});
